module.exports = __webpack_public_path__ + "static/skill-koalas-401e9b158b38942ee3984a17dcafdb7d.png";